<template>
  <vue100vh style="position: fixed; width: 100%;">
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage('/mobile/homepage')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title class="ml-0">One Anonymous</v-toolbar-title>
    </v-toolbar>
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">{{$t('Anonymous.manageGroup')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      </v-card>

      <v-container grid-list-md style="max-height: 35vh; overflow: scroll;">
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12  v-if="list_anonymous_owner.length > 0">
            <!-- {{list_anonymous_joined}} -->
            <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: rgb(255, 255, 255) !important; max-width: 100% !important; cursor: auto;" v-for="(item, index) in list_anonymous_owner">
              <!-- <div avatar   style="padding-top: 0px;" > -->
                <v-list-tile  avatar>
                  <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                    <v-list-tile-title class="fontselect " style="font-size:13px;" >
                      {{item.pseudonym}}

                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action style="width:30%;display: inline;margin-top: 30px;">
                      <v-btn depressed style="background-color: white;border-radius: 50px;color: #536475; padding-left: 9px; padding-right: 9px;text-transform: none; border: #536475 solid 1px;" @click="openCreateGroup(item)">
                        {{$t('Anonymous.createGroup')}}
                      </v-btn>
                      <v-btn depressed style="background-color: #536475;border-radius: 50px;color: white; padding-left: 9px; padding-right: 9px; border: #bebec1 1px solid; text-transform: none;" @click="openCreateBiz(item)">
                        {{$t('Anonymous.createBusiness')}}
                      </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
              <!-- </div> -->
              <v-divider ></v-divider>
            <!-- </template> -->
          </v-list>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12  v-else>
            <p>{{$t('Anonymous.noManageGroup')}}</p>
          </v-flex>
        </v-layout>
      </v-container>
    <v-card tile>
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text CSChatThai">{{$t('Anonymous.yourGroup')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>

    <v-container grid-list-md style="max-height: 35vh; overflow: scroll;">
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 v-if="list_anonymous_joined.length > 0">
            <!-- {{list_anonymous_joined}} -->
            <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: rgb(255, 255, 255) !important; max-width: 100% !important; cursor: auto;" v-for="(item, index) in list_anonymous_joined">
              <!-- <div avatar   style="padding-top: 0px;" > -->
                <v-list-tile  avatar>
                  <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                    <v-list-tile-title class="fontselect " style="font-size:13px;" >
                      {{item.pseudonym}}

                    </v-list-tile-title>
                    <!-- @click="showUserInGroup(item)" -->
                  </v-list-tile-content>
                  <v-list-tile-action style="width:30%;display: inline;margin-top: 30px;">
                      <!-- <v-btn depressed  style="background-color: #fb3e3e;border-radius: 50px;color: white; padding-left: 9px; padding-right: 9px;text-transform: none;" @click="remove_friend(item)">
                        {{$t('AnswerQuestion.removeFriend')}}
                      </v-btn>
                      <v-btn depressed  style="background-color: #536475;border-radius: 50px;color: white; padding-left: 9px; padding-right: 9px; border: #bebec1 1px solid; text-transform: none;" @click="unblock(item)">
                         {{$t('AnswerQuestion.unblock')}}
                      </v-btn> -->
                    </v-list-tile-action>
                </v-list-tile>
              <!-- </div> -->
              <v-divider ></v-divider>
            <!-- </template> -->
          </v-list>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12  v-else>
            <p>{{$t('Anonymous.noYourManageGroup')}}</p>
          </v-flex>
        </v-layout>
    </v-container>
  <createGroupAno :dialogGroup="dialogGroup" @closeDialogCreateGroup_ano="closeDialogCreateGroup_ano" :anoGroupDetail="anoGroupDetail"></createGroupAno>
  </div>
</vue100vh>
</template>
<script type="text/javascript">
import vue100vh from 'vue-100vh'
import createGroupAno from '@/components/mobile/dialog/CreateGroup_anoDialog'
import { Decode } from '@/services'
export default {
  data: () => ({
    list_anonymous_joined: [],
    list_anonymous_owner: [],
    token: '',
    dialogGroup: false,
    anoGroupDetail: {}
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.get_anonymousjoined()
    this.get_anonymousowner()
  },
  components: {
    createGroupAno,
    vue100vh
  },
  methods: {
    toPage (path) {
      this.$router.push(path)
    },
    closeDialogCreateGroup_ano () {
      this.dialogGroup = false
    },
    openCreateGroup (item) {
      this.dialogGroup = true
      this.anoGroupDetail = item
    },
    get_anonymousjoined () {
      this.axios.post(process.env.APIgo_api + '/v1/get-anonymous-joined', {
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.list_anonymous_joined = response.data.group_joined
        }
      }, () => {
        console.log('error')
      })
    },
    get_anonymousowner () {
      this.axios.post(process.env.APIgo_api + '/v1/get-anonymous-owner', {
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.list_anonymous_owner = response.data.group_owner
        }
      }, () => {
        console.log('error')
      })
    },
    openCreateBiz (item) {
      // var url = 'https://testoneid.inet.co.th/login?redirect_url=https://uat-business.one.th/business/create&shared_token='
      var body = {
        "tokenuser": this.token,
        "url": process.env.WebAnonymous
      }
      this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
        window.open(process.env.WebAnonymous  + response.data.data.accesstoken, '_blank')
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/settings/Anonymousone.vue